export default __webpack_public_path__ + "static/media/check_mark.390151e4.svg";